module.exports = __webpack_public_path__ + "static/media/personImportTemporary.a4815b0d.xlsx";